import type { Entity } from "./adapter";

const airportMontreal: Entity = {
  destinationId: "YUL",
  name: "Montreal-Trudeau Intl. Airport (YUL)",
  code: "YUL",
  latitude: 45.47,
  longitude: -73.7408,
  tts: true,
  type: "AIRPORTGROUP",
  ttsDestinationCode: "163",
  cubaDestination: false,
  useSPABookingFlow: false,
};

export default airportMontreal;
